export default "__VITE_ASSET__r6YtF0b0__"